import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MaintenanceMode from './MaintenanceMode';

const MaintenanceWrapper = ({ children }) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Check if maintenance mode is enabled
    const websiteSettings = JSON.parse(localStorage.getItem('websiteSettings') || '{}');
    const maintenanceMode = websiteSettings.maintenanceMode || false;
    
    // Check if user is admin
    const adminStatus = localStorage.getItem('isAdminAuthenticated') === 'true';
    
    setIsMaintenanceMode(maintenanceMode);
    setIsAdmin(adminStatus);
  }, [location.pathname]);

  // Allow access to admin page and visual editor always
  if (location.pathname === '/admin' || location.pathname === '/visual-editor') {
    return children;
  }

  // If maintenance mode is on and user is not admin, show maintenance page
  if (isMaintenanceMode && !isAdmin) {
    return <MaintenanceMode />;
  }

  // Show warning banner for admins when in maintenance mode
  if (isMaintenanceMode && isAdmin) {
    return (
      <>
        <div className="fixed top-0 left-0 right-0 bg-yellow-500 text-black text-center py-2 font-semibold z-50">
          ⚠️ Maintenance Mode is ON - Only you can see the site
        </div>
        <div className="pt-10">
          {children}
        </div>
      </>
    );
  }

  // Normal access
  return children;
};

export default MaintenanceWrapper;
